import { buildPlane, ModelBuilder } from '../index'

describe('@gglib/graphics/formulas', () => {
  describe('buildPlane', () => {
    let builder: ModelBuilder

    beforeEach(() => {
      builder = new ModelBuilder()
    })

    it ('builds without errors', () => {
      expect(builder.vertexCount).toBe(0)
      buildPlane(builder)
      expect(builder.vertexCount).not.toBe(0)
    })
  })
})
